import React from 'react'
import 'css/markdown-styles.css'
import Helmet from 'react-helmet'
import { config } from 'config'
import { rhythm } from '../utils/typography'
import { Container } from 'react-responsive-grid'
import BlogHead from 'components/BlogHead'

module.exports = React.createClass({
  propTypes () {
    return {
      router: React.PropTypes.object,
    }
  },
  render () {
    const page = this.props.route.page
    const post = this.props.route.page.data

    const isBlogEntry = page.path.startsWith('/blog/');
    return (
      <div>
        <div className="markdown">
          <Helmet
            title={`${config.siteTitle} | ${post.title}`}
          />
          {isBlogEntry &&
            <div>
              <BlogHead data={post} />
              <Container
                style={{
                  maxWidth: 960,
                  paddingTop: 100,
                  minHeight: 800,
                  padding: `${rhythm(1)} ${rhythm(3/4)}`,
                }}
              >
                <div dangerouslySetInnerHTML={{ __html: post.body }} />
              </Container>
            </div>
          }

          {!isBlogEntry &&
            <Container
              style={{
                maxWidth: 960,
                paddingTop: 100,
                minHeight: 800,
                padding: `${rhythm(1)} ${rhythm(3/4)}`,
              }}
            >
              <h1>{post.title}</h1>
              <div dangerouslySetInnerHTML={{ __html: post.body }} />
            </Container>
          }
        </div>
      </div>
    )
  },
})



/** WEBPACK FOOTER **
 ** ../wrappers/md.js
 **/